import { useEffect, useSyncExternalStore } from 'react'
import { Issue } from './Issue'
import { IssuesStoreQuery } from './IssueStore'

const serverIssues: Issue[] = []

export function useAllIssues() {
  const issues = useSyncExternalStore(
    (onStoreChange) => {
      IssuesStoreQuery.allIssues().addListener(onStoreChange)
      return () => IssuesStoreQuery.allIssues().removeListener(onStoreChange)
    },
    () => {
      return IssuesStoreQuery.allIssues().getSnapshot()
    },
    () => serverIssues
  )

  useEffect(() => {
    IssuesStoreQuery.allIssues().reload()
  }, [])

  return issues
}
